"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalDataLookupNode = void 0;
const NODE_TYPE = 'LOCAL-DATA-LOOKUP';
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
class LocalDataLookupNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap) => {
            if (this.accessorMap && this.accessorMap.OFFLINE_ATTRIB_LOOKUP) {
                const inputs = await this.asynchronousResolveInputs(nodeMap);
                const { attributeValueSource } = inputs;
                const { aggregateType, attributeName } = this.config;
                if (aggregateType && attributeName && attributeValueSource) {
                    const lookupValue = await Promise.resolve(this.accessorMap.OFFLINE_ATTRIB_LOOKUP(aggregateType, attributeName, attributeValueSource, 1));
                    if (lookupValue) {
                        return {
                            output: lookupValue.length > 0,
                            aggregateId: lookupValue.length > 0 && lookupValue[0].id ? lookupValue[0].id : null,
                        };
                    }
                }
            }
            // Accessor was not available, can not run this transform
            return {
                output: null,
                aggregateId: null,
            };
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('Attribute lookup is not allowed as a synchronously resolving node');
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
}
exports.LocalDataLookupNode = LocalDataLookupNode;
LocalDataLookupNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'On Device Lookup',
    isIdempotent: false,
    primaryCategory: 'Data Lookup',
};
//# sourceMappingURL=LocalDataLookup.js.map